import { Component, OnInit } from '@angular/core';
import { SandboxPage } from 'src/app/model/page/sandbox-page';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';

@Component({
  selector: 'app-view-sandbox-page-state',
  templateUrl: './view-sandbox-page-state.component.html',
  styleUrls: ['./view-sandbox-page-state.component.scss']
})
export class ViewSandboxPageStateComponent implements OnInit {
  constructor(private sandboxPageStateService: SandboxPageStateService) {}

  ngOnInit(): void {}

  getSandboxPageState(): SandboxPage {
    return this.sandboxPageStateService.getSandboxPage();
  }
}
